import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class PersonneContainer extends ShadowDOMElement {
	static className = "PersonneContainer";
	
	static properties = {
		name: { type: String, attribute: "name" },
		visible: {
			type: Boolean, attribute: "visible", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		greffe : {
			type: Boolean, attribute: "greffe", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		rcsLocation : {
			type: Boolean, attribute: "rcs-location", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		representative : {
			type: Boolean, attribute: "representative", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		exercises : {
			type: Boolean, attribute: "exercises", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		sigle: { type: Boolean, attribute: "sigle", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		representativeName : {
			type: Boolean, attribute: "representative-name", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		representativeAddress : {
			type: Boolean, attribute: "representative-address", reflect: true,
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};

	constructor() {
		super();
		this.name = `personne-type`;
		this.visible = true;
		this.rcsLocation = true;
	}

	render() {
    return html`
      <div style="display: ${this.visible ? 'block' : 'none'}">
        <row-wrapper>
          <radio-buttons-field
            name="${this.name}"
            .options="${[
              { title: "Personne physique", value: "physique" },
              { title: "Personne morale", value: "morale" },
            ]}"
            value="physique"
            @change="${this.handleRadioChange}"
          ></radio-buttons-field>
        </row-wrapper>
        <div-container id="physique-container" visible="true">
          <personne-physique exercises="${this.exercises}"></personne-physique>
        </div-container>
        <div-container id="morale-container" visible="false">
          <personne-morale-extended
			greffe="${this.greffe}"
			representative="${this.representative}"
			representative-name="${this.representativeName}"
			representative-address="${this.representativeAddress}"
			exercises="${this.exercises}"
			rcs-location="${this.rcsLocation}"
			sigle="${this.sigle}"
          ></personne-morale-extended>
        </div-container>
      </div>
    `;
	}

	handleRadioChange(event) {
		if (!event.detail)
			return;
		
		this.#updateContainers (event.detail.value);
	}
	
	#updateContainers (selectedValue){
		if (!selectedValue)
			selectedValue = this.shadowRoot.querySelectorAll ("radio-buttons-field")[0].value;
		
		const physiqueContainer = this.shadowRoot.querySelector ("#physique-container");
		const moraleContainer = this.shadowRoot.querySelector ("#morale-container");
	
		if (physiqueContainer && moraleContainer) {
			if (selectedValue === "physique") {
				physiqueContainer.visible = true;
				moraleContainer.visible = false;
			} else if (selectedValue === "morale") {
				physiqueContainer.visible = false;
				moraleContainer.visible = true;
			} else {
				physiqueContainer.visible = false;
				moraleContainer.visible = false;
			}
		}
	}
	
	isTransient (){
		return false;
	}
	
	getValues (){
		return {
			"visible" : this.visible,
			"greffe" : this.greffe,
			"representative" : this.representative,
			... super.getValues ()
		}
	}
	
	setValues (values){
		this.visible = values.visible;
		this.greffe = values.greffe;
		this.representative = values.representative;
		this.requestUpdate ();
		super.setValues (values);
		this.#updateContainers ();
	}
}

customElements.define ("personne-container", PersonneContainer);
